import { render, staticRenderFns } from "./PageBody.vue?vue&type=template&id=50e4da78&scoped=true"
import script from "./PageBody.vue?vue&type=script&lang=js"
export * from "./PageBody.vue?vue&type=script&lang=js"
import style0 from "./PageBody.vue?vue&type=style&index=0&id=50e4da78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4da78",
  null
  
)

/* custom blocks */
import block0 from "./PageBody.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports